import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import {FormControl, Validators} from '@angular/forms';

import { IncidentModel } from '../../main/Models';
import { toollist } from './form.tools';
import { globalData } from 'src/app/main/Models/global.model';
import { ApiService, DialogsService } from 'src/app/custom-material/Services';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
  selector: 'incident-form',
  templateUrl: './t_form.component.html',
  styleUrls: ['./form.component.less']
})
export class IncidentFormComponent implements OnInit {

  incident: IncidentModel;

  get gravity()
  {
    return this.incident.gravity;
  }
  set gravity(g)
  {
        this.incident.gravity = g;
  }

/*
  @Output()
  saveTriggered: EventEmitter<IncidentModel> = new EventEmitter();

  @Output()
  cancelTriggered: EventEmitter<IncidentModel> = new EventEmitter();
*/

  showErrors:boolean = false;


  constructor(
    private apiService: ApiService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogsService,
    public gd:globalData) { 
      this.gd.showChooser = false;
      this.gd.toolService = this;
      this.gd.toollist = toollist;
      this.gd.headerTitle = "Edition d'incident";
      this.gd.headerIcon = 'sync_problem';
    }

  ngOnInit() {
  	//if(this.incident.id == undefined) this.editMode = true;
    this.loadIncident().then(()=>{
            this.gd.headerBuilding = this.incident.building;
      this.gd.headerTitle = "Edition d'incident : "+this.incident.nature;
    });
  }

  loadIncident()
  {
    return new Promise((resolve, reject)=>{
      let id = +this.route.snapshot.params['incident'];
            if(isNaN(id)) {   //nouvel incident
        let buildingId =  +this.route.snapshot.params['building'];
                this.incident = new IncidentModel({ 
          building: this.gd.findBuildingById(buildingId),
          redactor: this.gd.connectedUser
        });
        this.gd.headerTitle = 'Nouvel incident';
        resolve(true); return;
      }


      if(this.gd.current!= undefined 
      && this.gd.current.constructor.name == 'IncidentModel'
      && this.gd.current.id == id) {
        this.incident = this.gd.current;
                this.gd.headerTitle = "Edition de l'incident "+this.incident.nature;
        resolve(true); return;
      }

      this.snackBar.open('Chargement en cours');
      this.apiService.getOneFromServer('incident',id)
      .then(s => s.subscribe((response:any) => {
        this.incident = new IncidentModel(response);
                this.gd.headerTitle = "Edition de l'incident "+this.incident.nature;
        this.snackBar.dismiss();
        resolve(true); return;
      }));
    });
  }

  control()
  {
    if(this.incident.nature!=''
    && this.incident.date!=''
    && this.incident.heure!='') {
      //this.saveTriggered.emit(this.incident);
      this.save(this.incident);
    } else {
      this.showErrors = true;
    }
  }

  save(incident: IncidentModel)
  {
    setTimeout(()=>{ this.snackBar.open('Sauvegarde en cours') }, 0);
    if(!incident.id) {
      this.apiService.SaveToServer('incident',incident.export())
        .then(s => s.subscribe((response:any) => {
          this.incident = new IncidentModel(response);
          //this.saveTriggered.emit(this.incident);
          setTimeout(()=>{ this.snackBar.open('Sauvegarde terminé') }, 0);
          setTimeout(()=>{ this.snackBar.dismiss() }, 2000);
          this.router.navigate(['/incidents', this.incident.id]);
        }));
    } else {
      this.apiService.UpdateToServer('incident',incident.export())
        .then(s => s.subscribe((response:any) => {
          this.incident.exchange(response);
          //this.saveTriggered.emit(this.incident);
          setTimeout(()=>{ this.snackBar.open('Sauvegarde terminé') }, 0);
          setTimeout(()=>{ this.snackBar.dismiss() }, 2000);
          this.router.navigate(['/incidents', this.incident.id]);
        }));
    }

  }


  cancel()
  {
    //this.cancelTriggered.emit(this.incident);
    if(this.incident.id == undefined) {
      this.router.navigate(['/incidents']);
    } else {
      this.router.navigate(['/incidents', this.incident.id]);
    }
  }
}
